import type { EventMarker } from '../types';

const FIVE_SECONDS = 5000;

export function maybeJumpstartPlayback(
  jumpStartEvent: EventMarker | undefined,
  onJumpstart: (jumpToTime: number) => void,
): boolean {
  const willJumpstartPlayback = !!(jumpStartEvent && jumpStartEvent.time > FIVE_SECONDS);

  if (willJumpstartPlayback) {
    const jumpToTime = Math.max(0, jumpStartEvent.time - FIVE_SECONDS);

    if (jumpToTime > 0) {
      setTimeout(() => onJumpstart(jumpToTime), 0);
    }
  }

  return willJumpstartPlayback;
}
